module.exports = __webpack_public_path__ + "static/media/sparq_icon.9b6a1a6f.png";